module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/msci0-6abac3874ec26b73bba3372ade7182cf.jpg";